const stringIsNotEmpty = string => ( string && string !== "" );
export default stringIsNotEmpty;